import {
    createContext,
    type Dispatch,
    type SetStateAction,
    useContext,
} from "react";

interface Settings {
    loadAllApplicants?: boolean;
}
interface SettingsContext {
    settings: Settings;
    setSettings: Dispatch<SetStateAction<Settings>>;
}

export const SettingsContext = createContext<SettingsContext>({
    settings: {},
    setSettings: () => {},
});

export const SettingsProvider = SettingsContext.Provider;
export const useSettingsContext = () => useContext(SettingsContext);
